import moment from "moment";

const calculateAge = (currentDate: any) => {
  const now = moment(new Date());
  const ageInYears = now.diff(currentDate, 'years');

  const ageUnits = [
    { unit: 'Years', value: ageInYears },
    { unit: 'Months', value: now.diff(currentDate, 'months') },
    { unit: 'Weeks', value: now.diff(currentDate, 'weeks') },
    { unit: 'Days', value: now.diff(currentDate, 'days') }
  ];

  let ageString = "New Born";

  for (const { unit, value } of ageUnits) {
    if (value > 0) {
      ageString = `${value} ${unit} old`;
      break;
    }
  }

  return ageString;
}

const convertToTimeString = (dateString: string) => {
  return (moment(dateString).format('h:mm A'))
}

const convertToDateString = (dateString: string) => {
  return moment(dateString).format('DD/MM/YYYY');

}

export { calculateAge, convertToTimeString, convertToDateString }